import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Paged} from "../interfaces/paged";
import {ActivatedRoute, Router} from "@angular/router";

export interface PaginatorItem {
  label: string;
  page: number;
  isEllipsis: boolean;
}

@Component({
    selector: 'bst-pager',
    templateUrl: './pager.component.html',
    styleUrls: ['./pager.component.scss'],
    standalone: false
})
export class PagerComponent<T> implements OnInit {

  @Input('paged') public paged: Paged<T>;
  @Input() public max: number = 1;
  @Input() public navigators: boolean = true;
  @Input() public disabled: boolean = false;
  @Input() public pageSize: number | null = null;
  @Input() public pageSizeOptions: number[] = [10, 25, 50, 100];
  @Output() public pageChange = new EventEmitter<number>();
  @Output() public pageSizeChange = new EventEmitter<number>();

  constructor(private route: ActivatedRoute,
              private router: Router){

  }

  ngOnInit(): void {
  }


  public pageTo(to: any){
    if (typeof to === 'string') {
      to = parseInt(to, 10);
    }
    if (isNaN(to)) return;
    this.pageChange.emit(to);
  }

  public firstPage(): void { this.pageTo(1); }
  public lastPage(): void { this.pageTo(this.paged.last_page); }

  public onPageSizeSelected(size: number): void {
    if (size === this.pageSize) return;
    this.pageSizeChange.emit(size);
  }

  public get pagnater(): PaginatorItem[] {
    const cur = Number(this.paged.current_page);
    const las = Number(this.paged.last_page);
    const items: PaginatorItem[] = [];

    if (las <= 8) {
      for (let i = 1; i <= las; i++) {
        items.push({ label: i.toString(), page: i, isEllipsis: false });
      }
    } else {
      if (cur <= 5) {
        for (let i = 1; i <= 6; i++) {
          items.push({ label: i.toString(), page: i, isEllipsis: false });
        }
        items.push({ label: '...', page: 7, isEllipsis: true });
        items.push({ label: las.toString(), page: las, isEllipsis: false });
      } else if (cur > las - 5) {
        items.push({ label: '1', page: 1, isEllipsis: false });
        items.push({ label: '...', page: las - 6, isEllipsis: true });
        for (let i = las - 5; i <= las; i++) {
          items.push({ label: i.toString(), page: i, isEllipsis: false });
        }
      } else {
        items.push({ label: '1', page: 1, isEllipsis: false });
        items.push({ label: '...', page: cur - 3, isEllipsis: true });
        items.push({ label: (cur - 2).toString(), page: cur - 2, isEllipsis: false });
        items.push({ label: (cur - 1).toString(), page: cur - 1, isEllipsis: false });
        items.push({ label: cur.toString(), page: cur, isEllipsis: false });
        items.push({ label: (cur + 1).toString(), page: cur + 1, isEllipsis: false });
        items.push({ label: '...', page: cur + 2, isEllipsis: true });
        items.push({ label: las.toString(), page: las, isEllipsis: false });
      }
    }

    return items;
  }

}
